import { useStore } from '@/store/store';
export const changeTheme = (theme) => {
    const store = useStore();
    const globalStyleElement = document.getElementById('global_style_css');
    globalStyleElement.href = `/css/themes/styles_${theme ? theme : store.getters.theme}.css`;
};
